<template>
  <div class="my-3">
    <CFormInput placeholder="請填入文字" />
  </div>
</template>
